// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__lbA3R","backButton":"ModalHeader_backButton__suNrm","Button":"ModalHeader_Button__IRBHt"};